export default __webpack_public_path__ + "static/media/Apple.16e6f78c.png";